export const normal = 400
export const semibold = 500
export const bold = 600
